// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ExamPage from './pages/ExamPage';
import ResultPage from './pages/ResultPage';
import './App.css';
import CreateExamPage from './pages/CreateExamPage';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <img
            src="/logo-instituicao.svg"
            alt="Logo FAPAM"
            className="header-logo"
          />
          <h1 className="header-title">VESTIBULAR FAPAM 2027/1</h1>
        </header>
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/:examCode" element={<HomePage />} />
            <Route path="/create-exam" element={<CreateExamPage />} />
            <Route path="/exam/:examCode" element={<ExamPage />} />
            <Route path="/result/:examCode" element={<ResultPage />} />
          </Routes>
        </main>
        <footer>
          <p>© 2027 FAPAM — Faculdade Católica de Pará de Minas</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
